/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import history from '../../history';

function isLeftClickEvent(event) {
  return event.button === 0;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

function handleClick(props, event) {
  if (props.onClick) {
    props.onClick(event);
  }

  if (isModifiedEvent(event) || !isLeftClickEvent(event)) {
    return;
  }

  if (event.defaultPrevented === true) {
    return;
  }

  event.preventDefault();
  history.push(props.to);
}

export default function Link(props) {
  const { to, children, ...attrs } = props;
  let activeClass = attrs.activeClassName;
  delete attrs.activeClassName;
  let className = attrs.className;
  delete attrs.className;
  if(history.location !== undefined ) {
    
    /* if(history.location.pathname == to || (history.location.pathname  == "/admin/game/quarter-add" &&  to == '/admin/game/add') || (history.location.pathname.search(to) >= 0) || (history.location.pathname.search('/guest'))) {
      className += className + ' ' + activeClass;
    } */
    
    if(activeClass !== '' && activeClass !== undefined && activeClass !== null) {
      className += ' ' + activeClass;
    }

  }

  return (
    <a href={to} className={className} {...attrs} onClick={e => handleClick(props, e)}>
      {children}
    </a>
  );
}

Link.propTypes = {
  to: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
};

Link.defaultProps = {
  onClick: null,
};
